// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Colors */
/* Layout tokens */
/* Export CSS variables */
:root {
  --page-bg: #f6f7f9;
  --panel-bg: #ffffff;
  --muted: #6b7280;
  --text: #0f1724;
  --accent-green: #2ea44f;
  --accent-yellow: #ffb020;
  --accent-orange: #ff7a00;
  --danger: #d9534f;
  --card-border: rgba(15, 23, 42, 0.06);
  --radius-lg: 10px;
  --radius-md: 8px;
  --shadow-soft: 0 10px 30px rgba(16, 24, 40, 0.06);
  --gutter: 24px;
  --max-width: 1180px;
  --font-stack: Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica Neue, Arial;
}

@media (min-width: 992px) {
  .easyPaySettings_g-font-size-lg-30__HUXbq, .easyPaySettings_gfs-lg-30__Icdub {
    font-size: 30px !important;
  }
}
.easyPaySettings_g-font-size-lg-30__HUXbq, .easyPaySettings_gfs-lg-30__Icdub {
  font-size: 30px !important;
}

.easyPaySettings_mb-10__0hJVV {
  margin-bottom: 10px !important;
}

.easyPaySettings_g-line-height-1_2__6ohss, .easyPaySettings_glh-1_2__mBVnt {
  line-height: 1.2 !important;
}

.easyPaySettings_text-gray-med__VcfMH {
  color: #9e9e9e !important;
}

.easyPaySettings_g-font-weight-300__9XPIT, .easyPaySettings_gfw-3__pS4aW {
  font-weight: 300 !important;
}

.easyPaySettings_font-italic__DjSU1 {
  font-style: italic !important;
}

.easyPaySettings_tru-mma-main-add__hl90T, .easyPaySettings_tru-mma-main-content-box__s4EPt, .easyPaySettings_tru-mma-main-service-box__x7I0C {
  border: 1px solid #6c757d;
}

.easyPaySettings_mb-16__UKB7z {
  margin-bottom: 16px !important;
}

@media (min-width: 768px) {
  .easyPaySettings_tru-mma-main-wrapper__xI10L, .easyPaySettings_tru-mma-main-content-box__s4EPt, .easyPaySettings_tru-mma-main-content__uWC6n {
    background: #fafafa !important;
  }
}
.easyPaySettings_tru-mma-main-wrapper__xI10L, .easyPaySettings_tru-mma-main-content-box__s4EPt, .easyPaySettings_tru-mma-main-content__uWC6n {
  background: #fff;
}

.easyPaySettings_p-30__c3hom {
  padding: 30px !important;
}

.easyPaySettings_g-font-weight-300__9XPIT, .easyPaySettings_gfw-3__pS4aW {
  font-weight: 300 !important;
}

.easyPaySettings_tru-mma-main-content-box__s4EPt .easyPaySettings_text-md-left__Te3Hy {
  text-align: left !important;
}
.easyPaySettings_tru-mma-main-content-box__s4EPt .easyPaySettings_text-danger__EvD\\+t {
  color: #d1002f !important;
  margin-left: 10px;
}
.easyPaySettings_tru-mma-main-content-box__s4EPt .easyPaySettings_gfs-lg-30__Icdub {
  font-size: 30px;
}
.easyPaySettings_tru-mma-main-content-box__s4EPt .easyPaySettings_gfs-lg-20__Bskbo {
  font-size: 20px;
}
.easyPaySettings_tru-mma-main-content-box__s4EPt .easyPaySettings_text-gray-dark__c89rF {
  color: #666666;
}
.easyPaySettings_tru-mma-main-content-box__s4EPt .easyPaySettings_text-green__k1gww {
  color: #73c573;
}
.easyPaySettings_tru-mma-main-content-box__s4EPt .easyPaySettings_js-phoneno__6sO6E {
  color: #73c573;
  text-decoration: none;
}
.easyPaySettings_tru-mma-main-content-box__s4EPt .easyPaySettings_gfs-14__ryawn {
  font-size: 14px;
}

.easyPaySettings_text-center__gk4F4 {
  text-align: center !important;
}

.easyPaySettings_mb-10__0hJVV {
  margin-bottom: 10px !important;
}

.easyPaySettings_g-font-weight-300__9XPIT, .easyPaySettings_gfw-3__pS4aW {
  font-weight: 300 !important;
}

.easyPaySettings_text-center__gk4F4 {
  text-align: center !important;
}

.easyPaySettings_g-font-size-16__lHOLO, .easyPaySettings_gfs-16__QmOum {
  font-size: 16px !important;
}

.easyPaySettings_g-line-height-1_2__6ohss, .easyPaySettings_glh-1_2__mBVnt {
  line-height: 1.2 !important;
}

@media (min-width: 992px) {
  .easyPaySettings_g-font-size-lg-30__HUXbq, .easyPaySettings_gfs-lg-30__Icdub {
    font-size: 30px !important;
  }
}
.easyPaySettings_g-font-size-24__UsLge, .easyPaySettings_gfs-24__JQEhg {
  font-size: 24px;
}

.easyPaySettings_g-line-height-1__Qvndu, .easyPaySettings_glh-1__5djHH {
  line-height: 1 !important;
}

.easyPaySettings_d-block__gAAsi {
  display: block !important;
}

.easyPaySettings_g-font-weight-300__9XPIT, .easyPaySettings_gfw-3__pS4aW {
  font-weight: 300 !important;
}

@media (max-width: 767px) {
  .easyPaySettings_tru-mma-main-content-box__s4EPt {
    border: 0;
  }
  .easyPaySettings_tru-mma-main-content-box__s4EPt .easyPaySettings_text-md-left__Te3Hy {
    text-align: center !important;
  }
  .easyPaySettings_tru-mma-main-content__uWC6n {
    background-color: none;
    background: #fff !important;
    border-bottom: 1px solid #9e9e9e;
  }
}
.easyPaySettings_text-center__gk4F4 {
  text-align: center !important;
}

.easyPaySettings_mb-5__yo1v9 {
  margin-bottom: 5px !important;
}

@media (min-width: 992px) {
  .easyPaySettings_g-font-size-lg-20__Lt9UE, .easyPaySettings_gfs-lg-20__Bskbo {
    font-size: 20px !important;
  }
}
.easyPaySettings_text-gray-dark__c89rF {
  color: #666 !important;
}

.easyPaySettings_d-block__gAAsi {
  display: block !important;
}

.easyPaySettings_g-font-weight-300__9XPIT, .easyPaySettings_gfw-3__pS4aW {
  font-weight: 300 !important;
}

@media (min-width: 992px) {
  .easyPaySettings_g-font-size-lg-20__Lt9UE, .easyPaySettings_gfs-lg-20__Bskbo {
    font-size: 20px !important;
  }
}
.easyPaySettings_tru-mma-main-link__AS0l4 {
  border-bottom: 1px solid #ffb034;
  color: #ffb034;
  text-decoration: none;
}

@media (min-width: 768px) {
  .easyPaySettings_tru-mma-main-wrapper__xI10L .easyPaySettings_tru-mma-main-content-box__s4EPt .easyPaySettings_tru-mma-main-content__uWC6n {
    background-color: #ffffff !important;
  }
}
.easyPaySettings_tru-mma-main-wrapper__xI10L .easyPaySettings_tru-mma-main-content-box__s4EPt .easyPaySettings_tru-mma-main-content__uWC6n {
  background: #fff;
}

.easyPaySettings_g-font-size-10__6vjlV, .easyPaySettings_gfs-10__E\\+V3L {
  font-size: 10px !important;
}

@media (min-width: 768px) {
  .easyPaySettings_tru-mma-main-wrapper__xI10L, .easyPaySettings_tru-mma-main-content-box__s4EPt, .easyPaySettings_tru-mma-main-side__iSW\\+G {
    border-left: 1px solid #6c757d !important;
  }
}
.easyPaySettings_p-0__XGDfc {
  padding: 0 !important;
}

@media (min-width: 992px) {
  .easyPaySettings_text-lg-left__ZL8ce {
    text-align: left !important;
  }
}
.easyPaySettings_bg-white__HvCDb {
  color: #666;
}

.easyPaySettings_bg-white__HvCDb {
  background-color: #fff !important;
}

.easyPaySettings_p-10__lb7lr {
  padding: 10px !important;
}

@media (min-width: 992px) {
  .easyPaySettings_text-lg-left__ZL8ce {
    text-align: left !important;
  }
}
.easyPaySettings_g-font-size-16__lHOLO, .easyPaySettings_gfs-16__QmOum {
  font-size: 16px !important;
}

.easyPaySettings_g-font-weight-300__9XPIT, .easyPaySettings_gfw-3__pS4aW {
  font-weight: 300 !important;
}

.easyPaySettings_g-line-height-1_2__6ohss, .easyPaySettings_glh-1_2__mBVnt {
  line-height: 1.2 !important;
}

@media (min-width: 992px) {
  .easyPaySettings_g-font-size-lg-16__B3sai, .easyPaySettings_gfs-lg-16__bswrJ {
    font-size: 16px !important;
  }
}
@media (min-width: 992px) {
  .easyPaySettings_g-font-size-lg-14__ujveE, .easyPaySettings_gfs-lg-14__2bclU {
    font-size: 14px !important;
  }
}
@media (min-width: 768px) {
  .easyPaySettings_g-font-size-md-26__7b4Gd, .easyPaySettings_gfs-md-26__jNoKv {
    font-size: 26px !important;
  }
}
.easyPaySettings_g-font-size-50__xX2fG, .easyPaySettings_gfs-50__O3440 {
  font-size: 50px !important;
}

.easyPaySettings_g-font-weight-700__x6HKu, .easyPaySettings_gfw-7__U01qZ {
  font-weight: 700 !important;
}

@media (min-width: 992px) {
  .easyPaySettings_g-font-size-lg-14__ujveE, .easyPaySettings_gfs-lg-14__2bclU {
    font-size: 14px !important;
  }
}
@media (min-width: 768px) {
  .easyPaySettings_g-font-size-md-26__7b4Gd, .easyPaySettings_gfs-md-26__jNoKv {
    font-size: 26px !important;
  }
}
.easyPaySettings_g-font-size-50__xX2fG, .easyPaySettings_gfs-50__O3440 {
  font-size: 50px !important;
}

.easyPaySettings_g-font-weight-700__x6HKu, .easyPaySettings_gfw-7__U01qZ {
  font-weight: 700 !important;
}

@media (min-width: 768px) {
  .easyPaySettings_g-font-size-md-16__1RkD4, .easyPaySettings_gfs-md-16__URORv {
    font-size: 16px !important;
  }
}
.easyPaySettings_g-font-size-26__FbVas, .easyPaySettings_gfs-26__QTbRI {
  font-size: 26px !important;
}

sup {
  top: -0.5em;
}

@media (min-width: 992px) {
  .easyPaySettings_g-font-size-lg-14__ujveE, .easyPaySettings_gfs-lg-14__2bclU {
    font-size: 14px !important;
  }
}
.easyPaySettings_g-font-size-10__6vjlV, .easyPaySettings_gfs-10__E\\+V3L {
  font-size: 10px !important;
}

.easyPaySettings_tru-mma-main-side-update__lyqQ0 {
  line-height: 40px;
}

@media (min-width: 992px) {
  .easyPaySettings_g-font-size-lg-14__ujveE, .easyPaySettings_gfs-lg-14__2bclU {
    font-size: 14px !important;
  }
}
.easyPaySettings_g-font-size-20__5PE4a, .easyPaySettings_gfs-20__tUHOB {
  font-size: 20px;
}

.easyPaySettings_bg-green__Xk2Fu {
  background: #73c573;
  color: #fff;
  text-decoration: none !important;
}

@media (min-width: 768px) {
  .easyPaySettings_tru-mma-main-wrapper__xI10L .easyPaySettings_tru-mma-main-content-box__s4EPt .easyPaySettings_tru-mma-main-side__iSW\\+G {
    border-left: 1px solid #6c757d;
  }
}
.easyPaySettings_tru-mma-main-wrapper__xI10L {
  box-shadow: 0 3px 5px 0 hsla(0, 0%, 84.7%, 0.75) !important;
  border: 1px solid #ced4da !important;
}

.easyPaySettings_bg-gray-100__xQtDD {
  background-color: #f5f5f5 !important;
}

@media (min-width: 768px) {
  .easyPaySettings_p-md-30__0XR24 {
    padding: 30px !important;
  }
}
.easyPaySettings_mb-40__hdV2U {
  margin-bottom: 40px !important;
}

.easyPaySettings_bg-gray-100__xQtDD {
  background-color: #f2f3f6 !important;
}

@media (min-width: 768px) {
  .easyPaySettings_p-md-30__0XR24 {
    padding: 30px !important;
  }
}
.easyPaySettings_mb-40__hdV2U {
  margin-bottom: 40px !important;
}

.easyPaySettings_bg-gray-100__xQtDD {
  background-color: #f5f5f5 !important;
}

@media (max-width: 767px) {
  .easyPaySettings_bg-gray-100__xQtDD {
    background-color: #ffffff !important;
    box-shadow: none !important;
    border: none !important;
    padding-top: 20px;
  }
}
@media (min-width: 768px) {
  .easyPaySettings_g-font-size-md-10__yVmC0, .easyPaySettings_gfs-md-10__dLD0Q {
    font-size: 10px !important;
  }
}
.easyPaySettings_bg-gray-300__nvmr4 {
  background-color: #9e9e9e !important;
}

.easyPaySettings_text-right__6iJXE {
  text-align: right !important;
}

.easyPaySettings_border-radius-0__r5Nd3 {
  border-radius: 0 !important;
}

.easyPaySettings_py-3__jmCeO {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
  padding-left: 0;
  padding-right: 0;
}

.easyPaySettings_mb-20__RArgi {
  margin-bottom: 20px !important;
}

.easyPaySettings_bg-yellow__WCzUW {
  background: #ffb034;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/styles/_easyPayTokens.scss","webpack://./src/styles/easyPaySettings.module.scss"],"names":[],"mappings":"AAGA,WAAA;AAaA,kBAAA;AAQA,yBAAA;AACA;EACI,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,wBAAA;EACA,wBAAA;EACA,iBAAA;EACA,qCAAA;EACA,iBAAA;EACA,gBAAA;EACA,iDAAA;EACA,cAAA;EACA,mBAAA;EACA,sFAAA;ACrBJ;;AAjBA;EACI;IACI,0BAAA;EAoBN;AACF;AAlBA;EACQ,0BAAA;AAoBR;;AAlBA;EACI,8BAAA;AAqBJ;;AAnBA;EACI,2BAAA;AAsBJ;;AAnBA;EACI,yBAAA;AAsBJ;;AApBA;EACI,2BAAA;AAuBJ;;AArBA;EACI,6BAAA;AAwBJ;;AApBA;EACI,yBAAA;AAuBJ;;AApBA;EACI,8BAAA;AAuBJ;;AArBA;EACK;IACG,8BAAA;EAwBN;AACF;AArBC;EACG,gBAAA;AAuBJ;;AArBA;EACI,wBAAA;AAwBJ;;AAtBA;EACI,2BAAA;AAyBJ;;AArBI;EACI,2BAAA;AAwBR;AArBI;EACI,yBAAA;EACA,iBAAA;AAuBR;AApBI;EACI,eAAA;AAsBR;AAnBI;EACI,eAAA;AAqBR;AAlBI;EACI,cAAA;AAoBR;AAjBI;EACI,cAAA;AAmBR;AAhBI;EACI,cAAA;EACA,qBAAA;AAkBR;AAfI;EACI,eAAA;AAiBR;;AAZA;EACI,6BAAA;AAeJ;;AAbA;EACI,8BAAA;AAgBJ;;AAdA;EACI,2BAAA;AAiBJ;;AAdA;EACI,6BAAA;AAiBJ;;AAfA;EACI,0BAAA;AAkBJ;;AAhBA;EACI,2BAAA;AAmBJ;;AAjBA;EACI;IACI,0BAAA;EAoBN;AACF;AAjBA;EACI,eAAA;AAmBJ;;AAjBA;EACI,yBAAA;AAoBJ;;AAlBA;EACI,yBAAA;AAqBJ;;AAnBA;EACI,2BAAA;AAsBJ;;AApBA;EAEI;IACI,SAAA;EAsBN;EArBM;IACI,6BAAA;EAuBV;EAnBE;IACI,sBAAA;IACA,2BAAA;IACA,gCAAA;EAqBN;AACF;AAnBA;EACI,6BAAA;AAqBJ;;AAnBA;EACI,6BAAA;AAsBJ;;AApBA;EACI;IACI,0BAAA;EAuBN;AACF;AArBA;EACI,sBAAA;AAuBJ;;AArBA;EACI,yBAAA;AAwBJ;;AAtBA;EACI,2BAAA;AAyBJ;;AAtBA;EACI;IACI,0BAAA;EAyBN;AACF;AAvBA;EACI,gCAAA;EACA,cAAA;EACA,qBAAA;AAyBJ;;AAvBA;EACI;IACI,oCAAA;EA0BN;AACF;AAxBA;EACI,gBAAA;AA0BJ;;AAxBA;EACI,0BAAA;AA2BJ;;AAxBA;EACI;IACI,yCAAA;EA2BN;AACF;AAzBA;EACI,qBAAA;AA2BJ;;AAzBA;EACI;IACI,2BAAA;EA4BN;AACF;AA1BA;EACI,WAAA;AA4BJ;;AA1BA;EACI,iCAAA;AA6BJ;;AA3BA;EACI,wBAAA;AA8BJ;;AA5BA;EACI;IACI,2BAAA;EA+BN;AACF;AA7BA;EACI,0BAAA;AA+BJ;;AA5BA;EACI,2BAAA;AA+BJ;;AA7BA;EACI,2BAAA;AAgCJ;;AA9BA;EACI;IACI,0BAAA;EAiCN;AACF;AA/BA;EACI;IACI,0BAAA;EAiCN;AACF;AA/BA;EACI;IACI,0BAAA;EAiCN;AACF;AA/BA;EACI,0BAAA;AAiCJ;;AA/BA;EACI,2BAAA;AAkCJ;;AAhCA;EACI;IACI,0BAAA;EAmCN;AACF;AAjCA;EACI;IACI,0BAAA;EAmCN;AACF;AAjCA;EACI,0BAAA;AAmCJ;;AAjCA;EACI,2BAAA;AAoCJ;;AAlCA;EACI;IACI,0BAAA;EAqCN;AACF;AAnCA;EACI,0BAAA;AAqCJ;;AAnCA;EACI,WAAA;AAsCJ;;AApCA;EACI;IACI,0BAAA;EAuCN;AACF;AArCA;EACI,0BAAA;AAuCJ;;AArCA;EACI,iBAAA;AAwCJ;;AAtCA;EACI;IACI,0BAAA;EAyCN;AACF;AAvCA;EACI,eAAA;AAyCJ;;AAvCA;EACI,mBAAA;EACA,WAAA;EACA,gCAAA;AA0CJ;;AAxCA;EACI;IACI,8BAAA;EA2CN;AACF;AAxCA;EACI,2DAAA;EACA,oCAAA;AA0CJ;;AAxCA;EACI,oCAAA;AA2CJ;;AAzCA;EACI;IACI,wBAAA;EA4CN;AACF;AA1CA;EACI,8BAAA;AA4CJ;;AA1CA;EACI,oCAAA;AA6CJ;;AA3CA;EACI;IACI,wBAAA;EA8CN;AACF;AA5CA;EACI,8BAAA;AA8CJ;;AA5CA;EACI,oCAAA;AA+CJ;;AA7CA;EACI;IACI,oCAAA;IACA,2BAAA;IACA,uBAAA;IACA,iBAAA;EAgDN;AACF;AA9CA;EACI;IACI,0BAAA;EAgDN;AACF;AA9CA;EACI,oCAAA;AAgDJ;;AA9CA;EACI,4BAAA;AAiDJ;;AA/CA;EACI,2BAAA;AAkDJ;;AAhDA;EACI,4BAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;AAmDJ;;AAjDA;EACI,8BAAA;AAoDJ;;AAlDA;EACI,mBAAA;EACA,WAAA;AAqDJ","sourcesContent":["// styles/_easyPayTokens.scss\n$font-stack: \"Inter\", system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial !default;\n\n/* Colors */\n$page-bg: #f6f7f9 !default;\n$panel-bg: #ffffff !default;\n$muted: #6b7280 !default;\n$text: #0f1724 !default;\n$accent-green: #2ea44f !default;\n$accent-green-600: #1f8a3a !default;\n$accent-yellow: #ffb020 !default;\n$accent-yellow-600: #e09b00 !default;\n$accent-orange: #ff7a00 !default;\n$danger: #d9534f !default;\n$card-border: rgba(15, 23, 42, 0.06) !default;\n\n/* Layout tokens */\n$radius-lg: 10px !default;\n$radius-md: 8px !default;\n$shadow-soft: 0 10px 30px rgba(16, 24, 40, 0.06) !default;\n$shadow-sm: 0 8px 24px rgba(16, 24, 40, 0.06) !default;\n$gutter: 24px !default;\n$max-width: 1180px !default;\n\n/* Export CSS variables */\n:root {\n    --page-bg: #{$page-bg};\n    --panel-bg: #{$panel-bg};\n    --muted: #{$muted};\n    --text: #{$text};\n    --accent-green: #{$accent-green};\n    --accent-yellow: #{$accent-yellow};\n    --accent-orange: #{$accent-orange};\n    --danger: #{$danger};\n    --card-border: #{$card-border};\n    --radius-lg: #{$radius-lg};\n    --radius-md: #{$radius-md};\n    --shadow-soft: #{$shadow-soft};\n    --gutter: #{$gutter};\n    --max-width: #{$max-width};\n    --font-stack: #{$font-stack};\n}","@use \"./_easyPayTokens\" as tokens;\n\n@media (min-width: 992px) {\n    .g-font-size-lg-30, .gfs-lg-30 {\n        font-size: 30px !important;\n    }\n}\n.g-font-size-lg-30, .gfs-lg-30 {\n        font-size: 30px !important;\n}\n.mb-10 {\n    margin-bottom: 10px !important;\n}\n.g-line-height-1_2, .glh-1_2 {\n    line-height: 1.2 !important;\n}\n\n.text-gray-med {\n    color: #9e9e9e !important;\n}\n.g-font-weight-300, .gfw-3 {\n    font-weight: 300 !important;\n}\n.font-italic {\n    font-style: italic !important;\n}\n\n// New\n.tru-mma-main-add,  .tru-mma-main-content-box,  .tru-mma-main-service-box {\n    border: 1px solid #6c757d;\n}\n\n.mb-16 {\n    margin-bottom: 16px !important;\n}\n@media (min-width: 768px) {\n     .tru-mma-main-wrapper, .tru-mma-main-content-box, .tru-mma-main-content {\n        background: #fafafa !important;\n    }\n}\n\n .tru-mma-main-wrapper, .tru-mma-main-content-box , .tru-mma-main-content {\n    background: #fff;\n}\n.p-30 {\n    padding: 30px !important;\n}\n.g-font-weight-300, .gfw-3 {\n    font-weight: 300 !important;\n}\n\n.tru-mma-main-content-box {\n    .text-md-left {\n        text-align: left !important;\n    }\n\n    .text-danger {\n        color: #d1002f !important;\n        margin-left: 10px;\n    }\n\n    .gfs-lg-30 {\n        font-size: 30px;\n    }\n\n    .gfs-lg-20 {\n        font-size: 20px;\n    }\n\n    .text-gray-dark {\n        color: #666666;\n    }\n\n    .text-green {\n        color: #73c573;\n    }\n\n    .js-phoneno {\n        color: #73c573;\n        text-decoration: none;\n    }\n\n    .gfs-14 {\n        font-size: 14px;\n    }\n\n}\n\n.text-center {\n    text-align: center !important;\n}\n.mb-10 {\n    margin-bottom: 10px !important;\n}\n.g-font-weight-300, .gfw-3 {\n    font-weight: 300 !important;\n}\n\n.text-center {\n    text-align: center !important;\n}\n.g-font-size-16, .gfs-16 {\n    font-size: 16px !important;\n}\n.g-line-height-1_2, .glh-1_2 {\n    line-height: 1.2 !important;\n}\n@media (min-width: 992px) {\n    .g-font-size-lg-30, .gfs-lg-30 {\n        font-size: 30px !important;\n    }\n}\n\n.g-font-size-24, .gfs-24 {\n    font-size: 24px;\n}\n.g-line-height-1, .glh-1 {\n    line-height: 1 !important;\n}\n.d-block {\n    display: block !important;\n}\n.g-font-weight-300, .gfw-3 {\n    font-weight: 300 !important;\n}\n@media (max-width: 767px) {\n    \n    .tru-mma-main-content-box {\n        border: 0;\n        .text-md-left {\n            text-align: center !important;\n        }\n    }\n    \n    .tru-mma-main-content {    \n        background-color: none;\n        background: #fff !important;\n        border-bottom: 1px solid #9e9e9e;\n    }\n}\n.text-center {\n    text-align: center !important;\n}\n.mb-5 {\n    margin-bottom: 5px !important;\n}\n@media (min-width: 992px) {\n    .g-font-size-lg-20, .gfs-lg-20 {\n        font-size: 20px !important;\n    }\n}\n.text-gray-dark {\n    color: #666 !important;\n}\n.d-block {\n    display: block !important;\n}\n.g-font-weight-300, .gfw-3 {\n    font-weight: 300 !important;\n}\n\n@media (min-width: 992px) {\n    .g-font-size-lg-20, .gfs-lg-20 {\n        font-size: 20px !important;\n    }\n}\n.tru-mma-main-link {\n    border-bottom: 1px solid #ffb034;\n    color: #ffb034;\n    text-decoration: none;\n}\n@media (min-width: 768px) {\n    .tru-mma-main-wrapper .tru-mma-main-content-box .tru-mma-main-content {\n        background-color: #ffffff !important;\n    }\n}\n.tru-mma-main-wrapper .tru-mma-main-content-box .tru-mma-main-content {\n    background: #fff;\n}\n.g-font-size-10, .gfs-10 {\n    font-size: 10px !important;\n}\n\n@media (min-width: 768px) {\n    .tru-mma-main-wrapper , .tru-mma-main-content-box , .tru-mma-main-side {\n        border-left: 1px solid #6c757d !important;\n    }\n}\n.p-0 {\n    padding: 0 !important;\n}\n@media (min-width: 992px) {\n    .text-lg-left {\n        text-align: left !important;\n    }\n}\n.bg-white {\n    color: #666;\n}\n.bg-white {\n    background-color: #fff !important;\n}\n.p-10 {\n    padding: 10px !important;\n}\n@media (min-width: 992px) {\n    .text-lg-left {\n        text-align: left !important;\n    }\n}\n.g-font-size-16, .gfs-16 {\n    font-size: 16px !important;\n}\n\n.g-font-weight-300, .gfw-3 {\n    font-weight: 300 !important;\n}\n.g-line-height-1_2, .glh-1_2 {\n    line-height: 1.2 !important;\n}\n@media (min-width: 992px) {\n    .g-font-size-lg-16, .gfs-lg-16 {\n        font-size: 16px !important;\n    }\n}\n@media (min-width: 992px) {\n    .g-font-size-lg-14, .gfs-lg-14 {\n        font-size: 14px !important;\n    }\n}\n@media (min-width: 768px) {\n    .g-font-size-md-26, .gfs-md-26 {\n        font-size: 26px !important;\n    }\n}\n.g-font-size-50, .gfs-50 {\n    font-size: 50px !important;\n}\n.g-font-weight-700, .gfw-7 {\n    font-weight: 700 !important;\n}\n@media (min-width: 992px) {\n    .g-font-size-lg-14, .gfs-lg-14 {\n        font-size: 14px !important;\n    }\n}\n@media (min-width: 768px) {\n    .g-font-size-md-26, .gfs-md-26 {\n        font-size: 26px !important;\n    }\n}\n.g-font-size-50, .gfs-50 {\n    font-size: 50px !important;\n}\n.g-font-weight-700, .gfw-7 {\n    font-weight: 700 !important;\n}\n@media (min-width: 768px) {\n    .g-font-size-md-16, .gfs-md-16 {\n        font-size: 16px !important;\n    }\n}\n.g-font-size-26, .gfs-26 {\n    font-size: 26px !important;\n}\nsup {\n    top: -.5em;\n}\n@media (min-width: 992px) {\n    .g-font-size-lg-14, .gfs-lg-14 {\n        font-size: 14px !important;\n    }\n}\n.g-font-size-10, .gfs-10 {\n    font-size: 10px !important;\n}\n.tru-mma-main-side-update {\n    line-height: 40px;\n}\n@media (min-width: 992px) {\n    .g-font-size-lg-14, .gfs-lg-14 {\n        font-size: 14px !important;\n    }\n}\n.g-font-size-20, .gfs-20 {\n    font-size: 20px;\n}\n.bg-green {\n    background: #73c573;\n    color: #fff;\n    text-decoration: none !important;\n}\n@media (min-width: 768px) {\n    .tru-mma-main-wrapper .tru-mma-main-content-box .tru-mma-main-side {\n        border-left: 1px solid #6c757d;\n    }\n}\n\n.tru-mma-main-wrapper {\n    box-shadow: 0 3px 5px 0 hsla(0, 0%, 84.7%, .75) !important;\n    border: 1px solid #ced4da !important;\n}\n.bg-gray-100 {\n    background-color: #f5f5f5 !important;\n}\n@media (min-width: 768px) {\n    .p-md-30 {\n        padding: 30px !important;\n    }\n}\n.mb-40 {\n    margin-bottom: 40px !important;\n}\n.bg-gray-100 {\n    background-color: #f2f3f6 !important;\n}\n@media (min-width: 768px) {\n    .p-md-30 {\n        padding: 30px !important;\n    }\n}\n.mb-40 {\n    margin-bottom: 40px !important;\n}\n.bg-gray-100 {\n    background-color: #f5f5f5 !important;\n}\n@media (max-width: 767px) {\n    .bg-gray-100 {\n        background-color: #ffffff !important;\n        box-shadow: none !important;\n        border: none !important;\n        padding-top: 20px;\n    }\n}\n@media (min-width: 768px) {\n    .g-font-size-md-10, .gfs-md-10 {\n        font-size: 10px !important;\n    }\n}\n.bg-gray-300 {\n    background-color: #9e9e9e !important;\n}\n.text-right{\n    text-align: right !important;\n}\n.border-radius-0{\n    border-radius: 0 !important;\n}\n.py-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n    padding-left: 0;\n    padding-right: 0;\n}\n.mb-20 {\n    margin-bottom: 20px !important;\n}\n.bg-yellow {\n    background: #ffb034;\n    color: #fff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"g-font-size-lg-30": `easyPaySettings_g-font-size-lg-30__HUXbq`,
	"gfs-lg-30": `easyPaySettings_gfs-lg-30__Icdub`,
	"mb-10": `easyPaySettings_mb-10__0hJVV`,
	"g-line-height-1_2": `easyPaySettings_g-line-height-1_2__6ohss`,
	"glh-1_2": `easyPaySettings_glh-1_2__mBVnt`,
	"text-gray-med": `easyPaySettings_text-gray-med__VcfMH`,
	"g-font-weight-300": `easyPaySettings_g-font-weight-300__9XPIT`,
	"gfw-3": `easyPaySettings_gfw-3__pS4aW`,
	"font-italic": `easyPaySettings_font-italic__DjSU1`,
	"tru-mma-main-add": `easyPaySettings_tru-mma-main-add__hl90T`,
	"tru-mma-main-content-box": `easyPaySettings_tru-mma-main-content-box__s4EPt`,
	"tru-mma-main-service-box": `easyPaySettings_tru-mma-main-service-box__x7I0C`,
	"mb-16": `easyPaySettings_mb-16__UKB7z`,
	"tru-mma-main-wrapper": `easyPaySettings_tru-mma-main-wrapper__xI10L`,
	"tru-mma-main-content": `easyPaySettings_tru-mma-main-content__uWC6n`,
	"p-30": `easyPaySettings_p-30__c3hom`,
	"text-md-left": `easyPaySettings_text-md-left__Te3Hy`,
	"text-danger": `easyPaySettings_text-danger__EvD+t`,
	"gfs-lg-20": `easyPaySettings_gfs-lg-20__Bskbo`,
	"text-gray-dark": `easyPaySettings_text-gray-dark__c89rF`,
	"text-green": `easyPaySettings_text-green__k1gww`,
	"js-phoneno": `easyPaySettings_js-phoneno__6sO6E`,
	"gfs-14": `easyPaySettings_gfs-14__ryawn`,
	"text-center": `easyPaySettings_text-center__gk4F4`,
	"g-font-size-16": `easyPaySettings_g-font-size-16__lHOLO`,
	"gfs-16": `easyPaySettings_gfs-16__QmOum`,
	"g-font-size-24": `easyPaySettings_g-font-size-24__UsLge`,
	"gfs-24": `easyPaySettings_gfs-24__JQEhg`,
	"g-line-height-1": `easyPaySettings_g-line-height-1__Qvndu`,
	"glh-1": `easyPaySettings_glh-1__5djHH`,
	"d-block": `easyPaySettings_d-block__gAAsi`,
	"mb-5": `easyPaySettings_mb-5__yo1v9`,
	"g-font-size-lg-20": `easyPaySettings_g-font-size-lg-20__Lt9UE`,
	"tru-mma-main-link": `easyPaySettings_tru-mma-main-link__AS0l4`,
	"g-font-size-10": `easyPaySettings_g-font-size-10__6vjlV`,
	"gfs-10": `easyPaySettings_gfs-10__E+V3L`,
	"tru-mma-main-side": `easyPaySettings_tru-mma-main-side__iSW+G`,
	"p-0": `easyPaySettings_p-0__XGDfc`,
	"text-lg-left": `easyPaySettings_text-lg-left__ZL8ce`,
	"bg-white": `easyPaySettings_bg-white__HvCDb`,
	"p-10": `easyPaySettings_p-10__lb7lr`,
	"g-font-size-lg-16": `easyPaySettings_g-font-size-lg-16__B3sai`,
	"gfs-lg-16": `easyPaySettings_gfs-lg-16__bswrJ`,
	"g-font-size-lg-14": `easyPaySettings_g-font-size-lg-14__ujveE`,
	"gfs-lg-14": `easyPaySettings_gfs-lg-14__2bclU`,
	"g-font-size-md-26": `easyPaySettings_g-font-size-md-26__7b4Gd`,
	"gfs-md-26": `easyPaySettings_gfs-md-26__jNoKv`,
	"g-font-size-50": `easyPaySettings_g-font-size-50__xX2fG`,
	"gfs-50": `easyPaySettings_gfs-50__O3440`,
	"g-font-weight-700": `easyPaySettings_g-font-weight-700__x6HKu`,
	"gfw-7": `easyPaySettings_gfw-7__U01qZ`,
	"g-font-size-md-16": `easyPaySettings_g-font-size-md-16__1RkD4`,
	"gfs-md-16": `easyPaySettings_gfs-md-16__URORv`,
	"g-font-size-26": `easyPaySettings_g-font-size-26__FbVas`,
	"gfs-26": `easyPaySettings_gfs-26__QTbRI`,
	"tru-mma-main-side-update": `easyPaySettings_tru-mma-main-side-update__lyqQ0`,
	"g-font-size-20": `easyPaySettings_g-font-size-20__5PE4a`,
	"gfs-20": `easyPaySettings_gfs-20__tUHOB`,
	"bg-green": `easyPaySettings_bg-green__Xk2Fu`,
	"bg-gray-100": `easyPaySettings_bg-gray-100__xQtDD`,
	"p-md-30": `easyPaySettings_p-md-30__0XR24`,
	"mb-40": `easyPaySettings_mb-40__hdV2U`,
	"g-font-size-md-10": `easyPaySettings_g-font-size-md-10__yVmC0`,
	"gfs-md-10": `easyPaySettings_gfs-md-10__dLD0Q`,
	"bg-gray-300": `easyPaySettings_bg-gray-300__nvmr4`,
	"text-right": `easyPaySettings_text-right__6iJXE`,
	"border-radius-0": `easyPaySettings_border-radius-0__r5Nd3`,
	"py-3": `easyPaySettings_py-3__jmCeO`,
	"mb-20": `easyPaySettings_mb-20__RArgi`,
	"bg-yellow": `easyPaySettings_bg-yellow__WCzUW`
};
export default ___CSS_LOADER_EXPORT___;
